import React from "react";
import { Link as RouterLink } from "react-router-dom";
import Standart from '../../assets/images/standart.jpg';
import Biznes from '../../assets/images/biznes.jpg';
import Premium from '../../assets/images/premium.png';

import { makeStyles } from "@material-ui/core/styles";
import { Container, Paper, Box, Typography, Theme, FormControl, InputLabel, Card, CardMedia } from "@material-ui/core/";

import { AddressSelect } from "./OrderForm";
import { useStore } from "../../store/StoreProvider";
import { observer } from "mobx-react";
import CustomButton from "../../shared/Button";
import { TRoute } from "../../store/Types";

const NavLink = React.forwardRef<HTMLAnchorElement>((props, ref) => (
	<RouterLink to='/profile' innerRef={ref} {...props} />
));

const useFormStyles = makeStyles((theme: Theme) => ({
	container: {
    padding: "24px",
    position: 'absolute',
    [theme.breakpoints.down('xs')]: {
      padding: '10px',
      top: '100px',
      width: '100%',
      height: 'calc(100% - 100px)',
    }
	},
	order: {
		padding: "16px 0",
    width: "486px",
    pointerEvents: 'all',
    borderRadius: '10px',
    paddingBottom: '34px',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      paddingBottom: '20px'
    }
	},
	orderContainer: {
    padding: "0 20px",
    [theme.breakpoints.down('xs')]: {
      padding: '0 16px' 
    }
	},
	message: {
    textAlign: 'left',
    padding: '0 24px',
    [theme.breakpoints.down('xs')]: {
      padding: '0'
    }
	},
	button: {
    marginTop: "30px",
    paddingLeft: '24px',
    paddingRight: '24px',
    [theme.breakpoints.down('xs')]: {
      marginTop: '12px'
    }
  },
  title: {
    fontWeight: 700,
    marginBottom: '16px',
    [theme.breakpoints.down('xs')]: {
      fontSize: '21px',
      marginBottom: '8px',
      textAlign: 'center'
    }
  },
  subtitle: {
    [theme.breakpoints.down('xs')]: {
      textAlign: 'center'
    }
  },
  formControl: {
    minWidth: "100%",
    position: 'relative',
    '&:first-child': {
      marginBottom: '8px'
    }
  },
  cardPaper: {
    position: 'absolute',
    pointerEvents: 'all',
    top: '164px',
    left: '24px',
    padding: '32px 46px',
    maxWidth: '486px',
    borderRadius: '10px',
    boxSizing: "border-box",
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      padding: '10px',
      bottom: 0,
      left: 0,
      top: 'auto',
      zIndex: 150
    }
  },
  cardWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  card: {
    width: '118px',
    height: '167px',
    marginRight: '20px',
    padding: '12px',
    cursor: 'pointer',
    borderRadius: '10px',
    boxSizing: 'border-box',
    opacity: 0.6,
    transition: `${theme.transitions.duration.short}ms ${theme.transitions.easing.easeInOut}`,
    '&:hover': {
      boxShadow: theme.shadows[5],
      opacity: 1
    },
    '&:last-child': {
      marginRight: '0'
    },
    [theme.breakpoints.down('xs')]: {
      padding: '8px',
      marginRight: '8px',
    }
  },
  cardActive: {
    boxShadow: theme.shadows[5],
    opacity: 1
  },
  caption: {
    fontSize: '11px',
    color: '#828282',
    lineHeight: '11px'
  },
  price: {
    lineHeight: 1
  },
  media: {
    width: '95px',
    height: '72px',
    marginTop: '12px'
  }
}));

const Order = () => {
  const { card, coordinates, resetCoordinates, getCoordinates, addresses } = useStore();
	const [route, setRoute] = React.useState<TRoute>({
		from: "",
		to: ""
  });
  const [activeTariff, setActiveTariff] = React.useState('standart');
	const classes = useFormStyles();

	const onChange = event => {
		let input = event.target;
		setRoute({ ...route, [input.name]: input.value });
	};

	const onSubmit = () => {
		getCoordinates(route);
  };

  const setTariff = (tariff: string) => () => setActiveTariff(tariff);

	return (
		<Container className={classes.container}>
			<Paper className={classes.order}>
				<Container className={classes.orderContainer}>
          {
            !card &&
            <Box className={classes.message}>
              <Typography variant="body1">
                Заполните данные банковской карты
              </Typography>
              <CustomButton classname={classes.button} component={NavLink}>
                Перейти в Профиль
              </CustomButton>
            </Box>
          }
          {
            !!coordinates.length &&
            <Box className={classes.message}>
              <Typography className={classes.title} variant='h4' align='left'>Заказ размещен</Typography>
              <Typography className={classes.subtitle} variant="body1" align='left'>
                Ваше такси уже едет к вам. Прибудет приблизительно через 10 минут.
              </Typography>
              <CustomButton fullWidth classname={classes.button} onClick={resetCoordinates}>
                Сделать новый заказ
              </CustomButton>
            </Box>
          }
          {
            card && !coordinates.length &&
            <>
              <FormControl className={classes.formControl}>
                <InputLabel htmlFor="from">Откуда</InputLabel>
                <AddressSelect
                  addressKey="from"
                  otherAddress={route.to}
                  onChange={onChange}
                  route={route}
                  values={addresses}
                />
              </FormControl>
              <FormControl className={classes.formControl}>
                <InputLabel htmlFor="to">Куда</InputLabel>
                <AddressSelect
                  addressKey="to"
                  otherAddress={route.from}
                  onChange={onChange}
                  route={route}
                  values={addresses}
                />
              </FormControl>
            </>
          }
				</Container>
			</Paper>
      {
        card && !coordinates.length &&
        <Paper className={classes.cardPaper} elevation={5}>
          <div className={classes.cardWrapper}>
            <Card
              className={`${classes.card} ${activeTariff === 'standart' && classes.cardActive}`}
              onClick={setTariff('standart')}
              elevation={3}
            >
              <Typography component='div' variant='body1'>Стандарт</Typography>
              <Typography className={classes.caption} variant='caption'>Стоимость</Typography>
              <Typography className={classes.price} variant='h6'>150P</Typography>
              <CardMedia className={classes.media} image={Standart} />
            </Card>
            <Card
              className={`${classes.card} ${activeTariff === 'biznes' && classes.cardActive}`}
              onClick={setTariff('biznes')}
              elevation={3}
            >
              <Typography component='div' variant='body1'>Бизнес</Typography>
              <Typography className={classes.caption} variant='caption'>Стоимость</Typography>
              <Typography className={classes.price} variant='h6'>250P</Typography>
              <CardMedia className={classes.media} image={Biznes} />
            </Card>
            <Card
              className={`${classes.card} ${activeTariff === 'premium' && classes.cardActive}`}
              onClick={setTariff('premium')}
              elevation={3}
            >
              <Typography component='div' variant='body1'>Премиум</Typography>
              <Typography className={classes.caption} variant='caption'>Стоимость</Typography>
              <Typography className={classes.price} variant='h6'>350P</Typography>
              <CardMedia className={classes.media} image={Premium} />
            </Card>
          </div>
          <CustomButton fullWidth onClick={onSubmit} classname={classes.button}>
            Заказать
          </CustomButton>
        </Paper>
      }
		</Container>
	);
};

export default observer(Order);
